var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastrConfirmInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C6.688 4 4 6.688 4 10C4 13.312 6.688 16 10 16C13.312 16 16 13.312 16 10C16 6.688 13.312 4 10 4ZM10.6 13H9.4V9.4H10.6V13ZM10.6 8.2H9.4V7L10.6 7V8.2Z",
    fill: "#477ED2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastrConfirmInfo);
export default __webpack_public_path__ + "static/media/toastr-confirm-info.cf05e09d74768f1e647a6e619c4f0ea1.svg";
export { ForwardRef as ReactComponent };